import { useTranslation } from "react-i18next";
import { LoadingOverlay } from "~/shared/ui/LoadingOverlay";

/**
 * "Key 자동 입력" 진행 중 표시. 메뉴가 닫힌 뒤 LLM 호출(수 초) 동안 진행 상황을
 * 알리고, 그 사이 다른 입력을 가볍게 막는다. 완료 시 성공/실패 토스트로 결과 안내.
 *
 * 공용 LoadingOverlay 의 얇은 래퍼 — 문구/네임스페이스만 주입.
 */
export function KeyGenLoadingOverlay() {
  const { t } = useTranslation("analysis-draft");
  return <LoadingOverlay text={t("loading.generatingKeys")} />;
}
